var ApiStatus = /*#__PURE__*/function (ApiStatus) {
  ApiStatus[ApiStatus["OK"] = 200] = "OK";
  ApiStatus[ApiStatus["BAD_REQUEST"] = 400] = "BAD_REQUEST";
  ApiStatus[ApiStatus["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  ApiStatus[ApiStatus["FORBIDDEN"] = 403] = "FORBIDDEN";
  ApiStatus[ApiStatus["CONFLICT"] = 409] = "CONFLICT";
  ApiStatus[ApiStatus["GONE"] = 410] = "GONE";
  ApiStatus[ApiStatus["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
  ApiStatus[ApiStatus["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
  ApiStatus[ApiStatus["FORBIDDEN_HCP_ACCOUNT"] = 18] = "FORBIDDEN_HCP_ACCOUNT";
  ApiStatus[ApiStatus["ANDROID_INTEGRITY_ERROR"] = 40] = "ANDROID_INTEGRITY_ERROR";
  ApiStatus[ApiStatus["LOCKOUT"] = 9] = "LOCKOUT";
  ApiStatus[ApiStatus["API_ERROR"] = 1] = "API_ERROR";
  ApiStatus[ApiStatus["SESSION_MANAGEMENT_ERROR"] = 20] = "SESSION_MANAGEMENT_ERROR";
  ApiStatus[ApiStatus["PATIENT_EXISTS"] = 2] = "PATIENT_EXISTS";
  ApiStatus[ApiStatus["INVALID_DATA_CODE"] = 4] = "INVALID_DATA_CODE";
  ApiStatus[ApiStatus["UNSUPPORTED_COUNTRY"] = 6] = "UNSUPPORTED_COUNTRY";
  ApiStatus[ApiStatus["WRONG_REGION"] = 5] = "WRONG_REGION";
  ApiStatus[ApiStatus["EXPIRED_EMAIL_TOKEN"] = 30] = "EXPIRED_EMAIL_TOKEN";
  ApiStatus[ApiStatus["EXPIRED_AUTH_TOKEN"] = 15] = "EXPIRED_AUTH_TOKEN";
  ApiStatus[ApiStatus["VERIFICATION_CODE_INCORRECT_CODE"] = 66] = "VERIFICATION_CODE_INCORRECT_CODE";
  ApiStatus[ApiStatus["VERIFICATION_CODE_EXPIRED_CODE"] = 65] = "VERIFICATION_CODE_EXPIRED_CODE";
  ApiStatus[ApiStatus["PHONE_NUMBER_ALREADY_EXISTS_CODE"] = 63] = "PHONE_NUMBER_ALREADY_EXISTS_CODE";
  return ApiStatus;
}(ApiStatus || {});
export default ApiStatus;